const initialState = {}

export default function currentUser (state = initialState, action) {
  switch (action.type) {
    case 'SET_CURRENT_USER':
      return {
        ...action.value
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/current-user.js